export const ALLOWED_PROJECT_LINK = /^\s*(https?:\/\/\S+|mailto:\S+)\s*$/i;

export function isAllowedProjectLink(link: string | null | undefined): boolean {
    return ALLOWED_PROJECT_LINK.test(link ?? '');
}

export function isMailLink(link: string): boolean {
    return link.trim().toLowerCase().startsWith('mailto:');
}
